import React, { useEffect, useState } from 'react'
import { toast } from "react-toastify";
import RouteModal from '../../../Component/BasicComponents/Modal/RouteModal';
import { Btn } from '../../../AbstractElements';
import RouteDropdown from '../../../Component/BasicComponents/Dropdowns/RouteDropdown';
import PaginatedRouteDropdown from '../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper';
import { getEmployeeList } from '../../Employee/hooks/EmployeeRepository';
import { useAddMTPForMonth, useMTPActions, useUpdateMTPForMonth } from './useMTP';
import { showToast } from '../../../utils/toastUtils';

type ProductCardProps = {
    setIsModalOpen?: any;
    isModalOpen?: any;
    toggleModal?: any;
    title?: any;
    checkAddEditStatus?: any;
    setCheckAddEditStatus?: any;
    rowData?: any;
    OrgUnitData?: any;
    mtpMonths?: any;
    mtpStatus?: any;

};
const MTPAddAndEditModal: React.FC<ProductCardProps> = ({ mtpStatus, mtpMonths, OrgUnitData, rowData, setIsModalOpen, isModalOpen, title, checkAddEditStatus, setCheckAddEditStatus }) => {
    const [modalValues, setModalValues] = useState<any>({
        orgUnitId: '',
        employeeId: '',
        mtpMonth: '',
        mtpStatus: '',
        mtpAction: '',
    })

    const { mutate } = useAddMTPForMonth();
    const { data: actionsData } = useMTPActions({ enable: true });
    const { mutate: updateMutate } = useUpdateMTPForMonth();
    // console.log('actionsDataHemu', actionsData)
    const handleClose = () => {
        setIsModalOpen(false);
        setCheckAddEditStatus('');
        setModalValues((prevState: any) => ({ ...prevState, orgUnitId: '', employeeId: '', mtpMonth: '', mtpStatus: '', mtpAction: '' }))
    }

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (checkAddEditStatus === 'Add' && !modalValues?.orgUnitId) {
            showToast.warning("Please select org unit.");
            return;
        }
        if (checkAddEditStatus === 'Add' && !modalValues?.employeeId?.id) {
            showToast.warning("Please select employee.");
            return;
        }
        if (checkAddEditStatus === 'Add' && !modalValues?.mtpMonth) {
            showToast.warning("Please select month.");
            return;
        }
        if (checkAddEditStatus !== 'Add' && !modalValues?.mtpStatus) {
            showToast.warning("Please select status.");
            return;
        }
        if (checkAddEditStatus !== 'Add' && modalValues?.mtpStatus === 'approved' && !modalValues?.mtpAction) {
            showToast.warning("Please select action.");
            return;
        }
        const body: any = {
            orgUnitId: Number(modalValues?.orgUnitId),
            employeeId: Number(modalValues?.employeeId?.id),
            mtpMonth: `${modalValues?.mtpMonth}`,
        };
        if (checkAddEditStatus === 'Add') {
            body['orgUnitId'] = Number(modalValues?.orgUnitId)
            body['employeeId'] = Number(modalValues?.employeeId?.id)
            body['mtpMonth'] = `${modalValues?.mtpMonth}`
        } else {
            body['mtpId'] = Number(rowData?.MtpId)
            body['mtpStatus'] = `${modalValues?.mtpStatus}`
            if (modalValues?.mtpStatus === 'approved') {
                body['mtpAction'] = `${modalValues?.mtpAction}`
            }
        }
        if (checkAddEditStatus === "Add") {
            mutate(body, {
                onSuccess: () => {
                    handleClose();
                },
            });
        } else {
            updateMutate(
                { body },
                {
                    onSuccess: () => {
                        handleClose();
                    },
                }
            );
        }
    };



    useEffect(() => {
        if (checkAddEditStatus === 'Edit') {
            setModalValues((prevState: any) => ({ ...prevState, mtpStatus: rowData?.MtpStatus }))
        }
    }, [checkAddEditStatus])


    return (
        <RouteModal
            isOpen={isModalOpen}
            toggle={() => { setIsModalOpen(!isModalOpen); setModalValues((prevState: any) => ({ ...prevState, orgUnitId: '', employeeId: '', mtpMonth: '', mtpStatus: '', mtpAction: '' })); }}
            title={title}
            // title="Add MTP"
            size="md"
            content={
                <form onSubmit={handleSubmit}>
                    <div className="row mb-0">
                        {checkAddEditStatus === 'Add' && <RouteDropdown
                            // isMulti={true}
                            asterisk={true}
                            options={OrgUnitData || []}
                            value={modalValues?.orgUnitId}
                            onChange={(value: any) => {
                                setModalValues((prevState: any) => ({ ...prevState, employeeId: '' }));
                                setModalValues((prevState: any) => ({ ...prevState, orgUnitId: value }));
                            }}
                            DropdownHeading="Org Unit"
                        />}
                        {checkAddEditStatus === 'Add' && <PaginatedRouteDropdown
                            DropdownHeading="Employee"
                            placeholder="Select Employee"
                            isMulti={false}
                            initialSelectedOptions={modalValues?.employeeId}
                            onChange={(val: any) => {
                                setModalValues((prevState: any) => ({ ...prevState, employeeId: val }));
                            }}
                            fetchOptions={async (page: number, search: string = "") => {
                                if (!modalValues?.orgUnitId) return [];
                                const res: any = await getEmployeeList({
                                    orgUnit: Number(modalValues?.orgUnitId),
                                    search,
                                    page,
                                    limit: 10,
                                });
                                return (
                                    res?.data?.Employees?.map((item: any) => ({
                                        id: item?.EmployeeId || '',
                                        label: item?.FirstName || '',
                                    })) || []
                                );
                            }}
                            dependencies={[modalValues?.orgUnitId]}
                            isDisabled={!modalValues?.orgUnitId}
                        />}
                        {checkAddEditStatus === 'Add' && <RouteDropdown
                            options={mtpMonths || []}
                            value={modalValues?.mtpMonth}
                            onChange={(value: any) => {
                                // console.log('month value',value);
                                setModalValues((prevState: any) => ({ ...prevState, mtpMonth: value }));
                            }}
                            DropdownHeading="Months"
                        />}
                        {checkAddEditStatus !== 'Add' && <RouteDropdown
                            options={mtpStatus || []}
                            value={modalValues?.mtpStatus}
                            onChange={(value: any) => {
                                // console.log('month value', value);
                                setModalValues((prevState: any) => ({ ...prevState, mtpStatus: value }));
                            }}
                            DropdownHeading="Status"
                        />}
                        {checkAddEditStatus !== 'Add' && modalValues?.mtpStatus === 'approved' && <RouteDropdown
                            options={actionsData?.data || []}
                            value={modalValues?.mtpAction}
                            onChange={(value: any) => {
                                setModalValues((prevState: any) => ({ ...prevState, mtpAction: value }));
                            }}
                            DropdownHeading="Actions"
                        />}

                        <div style={{ height: 20 }} />
                        <div className="d-flex justify-content-start gap-2">
                            <Btn
                                style={{ backgroundColor: "#43B9B2", color: "white" }}
                                type="submit"
                            >
                                {checkAddEditStatus === 'Add' ? 'Submit' : 'Update'}
                            </Btn>
                            <Btn
                                style={{
                                    backgroundColor: "#F9FAFC",
                                    color: "#000",
                                    border: "1px solid #E0E0E0",
                                }}
                                type="button"
                                onClick={() => { setIsModalOpen(false); setCheckAddEditStatus(''); setModalValues((prevState: any) => ({ ...prevState, orgUnitId: '', employeeId: '', mtpMonth: '', mtpStatus: '', mtpAction: '' })); }}
                            >
                                Cancel
                            </Btn>
                        </div>



                    </div>
                </form>
            }
        />
    )
}

export default MTPAddAndEditModal